"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setClusterData, setClusterSlug, setDevice } from "@/components/PageCluster/redux/slice";

const useSyncClusterData = ({ clusterData, ua, clusterSlug }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  if (store?.getState()?.cluster?.clusterSlug === clusterSlug) {
    return;
  } else {
    dispatch(setClusterData(clusterData));
    dispatch(setDevice(ua));
    dispatch(setClusterSlug(clusterSlug));
  }
};

export { useSyncClusterData };
